import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-body scroll-wrapper" }
const _hoisted_2 = { class: "inputs-wr" }
const _hoisted_3 = { class: "input-row form-group" }
const _hoisted_4 = { class: "input-wr" }
const _hoisted_5 = {
  key: 0,
  class: "error"
}
const _hoisted_6 = { class: "input-wr" }
const _hoisted_7 = {
  key: 0,
  class: "error"
}
const _hoisted_8 = { class: "content-resend" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "controls" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 1,
  class: "spinner spinner-small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $setup.props.isOpen,
    onClose: $setup.onClose,
    classes: ['phone-number-verification-modal']
  }, {
    content: _withCtx(() => [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "modal-header" }, [
        _createElementVNode("div", { class: "modal-title" }, "Verify the request with your mobile!"),
        _createElementVNode("div", { class: "line" })
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "label bold" }, "Phone Number", -1)),
              _createVNode($setup["Cleave"], {
                class: "input-default disabled-phone",
                placeholder: $setup.phonePlaceholder,
                disabled: true,
                modelValue: $setup.form.phone,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.phone) = $event)),
                options: $setup.phoneNumberOption($setup.form.phone)
              }, null, 8, ["placeholder", "modelValue", "options"]),
              ($setup.v$.phone.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($setup.v$.phone.$errors[0]?.$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "label bold" }, "Digit Code", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "input-default",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.digitCode) = $event)),
                placeholder: "6 digit code",
                type: "text",
                inputmode: "numeric",
                maxlength: "6",
                pattern: "d*",
                onKeydown: $setup.onlyAllowNumbers
              }, null, 544), [
                [_vModelText, $setup.form.digitCode]
              ]),
              ($setup.v$.digitCode.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString($setup.v$.digitCode.$errors[0]?.$message), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              class: _normalizeClass(["button-resend-code", { 'disabled-resend': $setup.isButtonDisabled || $setup.isLoading }]),
              disabled: $setup.isButtonDisabled || $setup.isLoading,
              onClick: $setup.onResendCode
            }, _toDisplayString($setup.resendButtonText), 11, _hoisted_9)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        (!$setup.isLoading)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button default primary large long",
              disabled: $setup.isLoading,
              onClick: $setup.onVerify
            }, "Verify", 8, _hoisted_11))
          : _createCommentVNode("", true),
        ($setup.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "button-cancel-border default large",
          onClick: $setup.onClose
        }, "Back")
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}